exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#div_configuration{\n  min-height: 367px;\n  width: 100%;\n  border-radius: 4px;\n  display: inline-block;\n  background-color: #fff;\n  padding: 0;\n  border: 1px solid #dadada;\n  margin-bottom: 20px;\n}\n\n.table-curved {\n  border-collapse:separate;\n  border: solid #f1f1f1 1px;\n  border-radius: 4px;\n  margin: auto;\n  width: 95%;\n  height: 200px;\n  background-color: #fafafa;\n}\n\n.table-curved tr:last-child td\n{\n    border-bottom-left-radius: 25px;\n    border-bottom-right-radius: 25px;\n    border-bottom: none;\n}\n\n.table-curved td{\n  padding: 15px;\n}\n\n.table-curved th{\n  padding: 15px;\n}\n\n.btn-table-sm-plus{\n    background-color: #5b6c72;\n    color: #fff;\n    font-size: 12px;\n    font-weight: normal;\n    padding: 1px 8px;\n}\n\n.btn-table-sm-delete{\n  background-color: #ff534f;\n  color: #fff;\n  font-size: 12px;\n  font-weight: normal;\n  padding: 1px 8px;\n}\n\n.ng-invalid {\n  border-color: red;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/configuration/configuration.component.css
// module id = ../../../../../src/app/pages/configuration/configuration.component.css
// module chunks = main